import { useSortable } from "@dnd-kit/sortable";
import { CSS } from "@dnd-kit/utilities";
import { getOrderTypeLabel } from "../constants/orderTypes";
import { MdDelete, MdModeEdit, MdDragIndicator } from "react-icons/md";

export default function SortableRow({
  row,
  handleEdit,
  setDeleteIndex,
  setDeleteModal,
}) {
  const { attributes, listeners, setNodeRef, transform, transition } =
    useSortable({ id: row._id });

  const style = {
    transform: CSS.Transform.toString(transform),
    transition,
    textAlign: "center",
  };

  return (
    <tr ref={setNodeRef} style={style} {...attributes}>
      <td
        {...listeners}
        {...attributes}
        style={{ cursor: "grab", touchAction: "none" }}
      >
        <MdDragIndicator size={18} />
      </td>
      <td>{row.streetName}</td>
      <td>
        {row.homeStart} to {row.homeEnd}
      </td>
      <td>{getOrderTypeLabel(row.sequenceType)}</td>
      <td style={{ textAlign: "center" }}>
        <button
          className="btn btn-sm btn-outline-primary border-0"
          style={{ cursor: "pointer" }}
          onClick={() => handleEdit(row)}
        >
          <MdModeEdit size={18} />
        </button>
        <button
          className="btn btn-sm btn-outline-danger border-0"
          style={{ cursor: "pointer" }}
          onClick={() => {
            setDeleteIndex(row._id);
            setDeleteModal(true);
          }}
        >
          <MdDelete size={18} />
        </button>
      </td>
    </tr>
  );
}
